function WaterNotification({ message }) {
  if (!message) return null

  return (
    <div className="absolute bottom-4 right-4 bg-blue-900/90 text-white text-xs sm:text-sm px-3 py-2 rounded-lg shadow-lg max-w-xs">
      {message}
    </div>
  )
}

export default WaterNotification
